import { Select } from 'antd'
import { useEffect, useState } from "react"
import { getEnumsOptions } from '@/utils/EnumUtil'

const EnumSelect = (props) => {

    const { enumtype } = props

    const [options, setOptions] = useState([])

    useEffect(() => {
        setOptions(getEnumsOptions(enumtype) || [])
    }, [props.biztype])

    const filterOption = (value, option) => {
        if (option.label.toLowerCase().indexOf(value.toLowerCase()) >= 0) {
            return true;
        }
        if (option.value.toString().toLowerCase().indexOf(value.toString().toLowerCase()) >= 0) {
            return true;
        }
        return false;
    };

    return (
        <Select
            showSearch
            {...props}
            options={options}
            filterOption={filterOption}
        />
    )
}

export default EnumSelect;